import React, { useState } from "react";
import {
  AppBar,
  Dialog,
  DialogContent,
  IconButton,
  Toolbar,
  Typography,
} from "@material-ui/core";
import { Close } from "@material-ui/icons";

function IconModal({ icon, title, children, open, setOpen, handleOpenModal }) {
  function handleClick() {
    setOpen(true);
    handleOpenModal();
  }

  function handleClose() {
    setOpen(false);
  }

  return (
    <>
      {icon && <IconButton onClick={handleClick}>{icon}</IconButton>}

      <Dialog
        onClose={handleClose}
        aria-labelledby="simple-dialog-title"
        open={open}
        style={{ minWidth: "160px" }}
      >
        <AppBar position="static" color="primary" elevation={1}>
          <Toolbar
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography color="inherit" variant="subtitle1">
              {title}
            </Typography>
            <IconButton onClick={handleClose} color="inherit">
              <Close />
            </IconButton>
          </Toolbar>
        </AppBar>

        <DialogContent>{children}</DialogContent>
      </Dialog>
    </>
  );
}

export default IconModal;
